import type { EmployeeViewModelWithName } from '../../types';

export function isEmployeeTerminated(uuid: string, employees: EmployeeViewModelWithName[]) {
  return (
    employees.find((e) => {
      return e.uuid === uuid && e.status === 'TERMINATED';
    }) !== undefined
  );
}
